import React from 'react';
import { GhlFormEmbed } from './GhlFormEmbed';
export function LeadFormSection() {
  return <section id="lead-form" className="w-full bg-ink" data-id="element-160" data-mp="1qoltb6bfondv">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-161" data-mp="1qq6pf0decedu">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14" data-id="element-162" data-mp="1cvw8h57n5oic">
          <div data-id="element-163" data-mp="1huz3dwtwqecl">
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-accent" data-id="element-164" data-mp="1huh9v7ymqe8d">Start here</p>
            <h2 className="mt-3 font-display text-[26px] font-semibold leading-[1.12] tracking-[-0.025em] text-white md:text-[38px]" data-id="element-165" data-mp="12xq3ufuga49s">
              See what a stronger agent operating system could look like for your business.
            </h2>
            <p className="mt-4 max-w-lg text-[15px] leading-relaxed text-white/70 md:mt-6 md:text-[17px]" data-id="element-166" data-mp="ywwjtxk4p9m6">
              Start with a private, no-pressure conversation about your current business, your goals, and where better
              systems, support, technology, or marketing could make the biggest difference.
            </p>
          </div>

          <GhlFormEmbed data-id="element-167" data-mp="6rvft9tcy8fy" />
        </div>
      </div>
    </section>;
}